<template>
  <v-container fluid>
    <div class="pt-5 pl-md-5 mb-10" style="max-width: 1000px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="submit"
      >
        <v-alert dense outlined type="error" v-if="error">
          <ul>
            <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
          </ul>
        </v-alert>
        <div>
          <h1 class="text-h5 mb-5">
            {{ $t("DA1") }}
          </h1>
          <p>{{ $t("DA2") }}</p>
        </div>
        <v-row>
          <v-col cols="12">
            <v-textarea
              outlined
              v-model="reason"
              v-bind:label="$t('DA3')"
              hide-details="auto"
              :rules="reqRules"
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              large
              color="light-blue"
              dark
              min-width="200px"
              rounded
              type="submit"
            >
              <span class="mr-2">{{ $t("ConfirmAndSubmit") }}</span>
              <v-icon size="small">mdi-arrow-right-thick</v-icon>
            </v-btn>
            <v-btn
              color="light-blue"
              class="ml-2"
              text
              :to="{
                name: 'Dashboard'
              }"
            >
              {{ $t("Nevermind") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <WaitDialogComponent :waitDialog="waitDialog" />
    </div>
  </v-container>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import AuthService from "@/services/AuthService";
import swal from "sweetalert";

export default {
  name: "DeactivateAccountComponent",
  mixins: [timeoutMixin],
  components: { WaitDialogComponent },
  data() {
    return {
      waitDialog: false,
      reason: "",
      valid: null,
      error: null,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  methods: {
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        await AuthService.acDeactivate({
          reason: this.reason
        })
          .then(result => {
            swal({
              icon: "success",
              text: result.data.message,
              button: {
                text: this.$t("Close"),
                className: "swal-close"
              }
            });
            this.$store.dispatch("logout");
            this.$router.push({ name: "Login" });
          })
          .catch(err => {
            this.error = err;
          });
        setTimeout(() => (this.waitDialog = false), 500);
      }
    }
  }
};
</script>

<style></style>
